import emailjs from "@emailjs/browser";

export async function sendMail(
  attrs: {
    name?: string;
    email?: string;
    message?: string;
    subject?: string;
  } = {}
): Promise<boolean> {
  const Id = "service_skggd0m";
  const templateId = "template_69h4flc";
  const Subject = "bluetweak request: " + attrs.subject;
  const Params = {
    name: attrs.name,
    email: attrs.email,
    message: attrs.message,
    subject: Subject,
  };
  try {
    await emailjs.send(Id, templateId, Params, {
      publicKey: "rZkAUEdR6DvR_D726",
    });
    return true;
  } catch (error) {
    console.log("FAILED...", error);
    return false;
  }
}
